import HekateOptionListElement from '../HekateForm/HekateOptionListElement';
export default class HekateOptionListDisplayElement extends HekateOptionListElement {
    constructor({ value, displayName, isOptGroup, }) {
        super({
            value,
            displayName,
        });
        this.isOptGroup = typeof isOptGroup !== 'undefined' ? isOptGroup : false;
    }
    /** return `ogtGroup` or `option` to be used with <template :is=""> */
    getTemplateName() {
        return this.isOptGroup ? 'optgroup' : 'option';
    }
}
